class ExposureFaqAccordion extends HTMLElement {
  connectedCallback() {
    if (this.dataset.multiple === 'true') return;

    this.details = Array.from(this.querySelectorAll('details'));

    this.details.forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;

        this.details.forEach((other) => {
          if (other !== detail) other.open = false;
        });
      });
    });
  }
}

if (!customElements.get('exposure-faq-accordion')) {
  customElements.define('exposure-faq-accordion', ExposureFaqAccordion);
}
